import { render } from "./CLabel.vue?vue&type=template&id=a2d243a4&ts=true&lang=pug"
import script from "./CLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLabel.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__